import * as React from "react";
const SvgFigma = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "#24CB71",
  d: "M4 20a4 4 0 0 1 4-4h4v4a4 4 0 0 1-8 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00B6FF",
  d: "M12 12a4 4 0 1 1 8 0 4 4 0 0 1-8 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#874FFF",
  d: "M4 12a4 4 0 0 0 4 4h4V8H8a4 4 0 0 0-4 4"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF7237",
  d: "M12 0v8h4a4 4 0 0 0 0-8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF3737",
  d: "M4 4a4 4 0 0 0 4 4h4V0H8a4 4 0 0 0-4 4"
}));
export default SvgFigma;
//# sourceMappingURL=Figma.js.map